import { ReactComponent as AnglesDown } from './AnglesDown.svg';
import { ReactComponent as AnglesUp } from './AnglesUp.svg';
import { ReactComponent as Badge } from './Badge.svg';
import { ReactComponent as BirthdayCake } from './BirthdayCake.svg';
import { ReactComponent as Bolt } from './Bolt.svg';
import { ReactComponent as Bookmark } from './Bookmark.svg';
import { ReactComponent as Calendar } from './Calendar.svg';
import { ReactComponent as CalendarCheck } from './CalendarCheck.svg';
import { ReactComponent as CaretLeft } from './CaretLeft.svg';
import { ReactComponent as CaretRight } from './CaretRight.svg';
import { ReactComponent as Checklist } from './Checklist.svg';
import { ReactComponent as ChevronDown } from './ChevronDown.svg';
import { ReactComponent as ChevronUp } from './ChevronUp.svg';
import { ReactComponent as CircleInfo } from './CircleInfo.svg';
import { ReactComponent as CirclePlus } from './CirclePlus.svg';
import { ReactComponent as Clock } from './Clock.svg';
import { ReactComponent as ClockEmpty } from './ClockEmpty.svg';
import { ReactComponent as Coin } from './Coin.svg';
import { ReactComponent as CoinStack } from './CoinStack.svg';
import { ReactComponent as Crown } from './Crown.svg';
import { ReactComponent as Discord } from './Discord.svg';
import { ReactComponent as Donation } from './Donation.svg';
import { ReactComponent as DoorOpen } from './DoorOpen.svg';
import { ReactComponent as EllipsisVertical } from './EllipsisVertical.svg';
import { ReactComponent as ExternalLink } from './ExternalLink.svg';
import { ReactComponent as Finish } from './Finish.svg';
import { ReactComponent as Gamepad } from './Gamepad.svg';
import { ReactComponent as Gauge } from './Gauge.svg';
import { ReactComponent as Grid } from './Grid.svg';
import { ReactComponent as Hashtag } from './Hashtag.svg';
import { ReactComponent as Heart } from './Heart.svg';
import { ReactComponent as History } from './History.svg';
import { ReactComponent as Home } from './Home.svg';
import { ReactComponent as Hornet } from './Hornet.svg';
import { ReactComponent as HourglassHalf } from './HourglassHalf.svg';
import { ReactComponent as IDCard } from './IDCard.svg';
import { ReactComponent as Link } from './Link.svg';
import { ReactComponent as Medal } from './Medal.svg';
import { ReactComponent as Patreon } from './Patreon.svg';
import { ReactComponent as Percent } from './Percent.svg';
import { ReactComponent as Puzzle } from './Puzzle.svg';
import { ReactComponent as QuestionCircle } from './QuestionCircle.svg';
import { ReactComponent as Refresh } from './Refresh.svg';
import { ReactComponent as Search } from './Search.svg';
import { ReactComponent as Spin } from './Spin.svg';
import { ReactComponent as SquareCheck } from './SquareCheck.svg';
import { ReactComponent as SquareMinus } from './SquareMinus.svg';
import { ReactComponent as SquarePlus } from './SquarePlus.svg';
import { ReactComponent as SquareX } from './SquareX.svg';
import { ReactComponent as StarBlack } from './StarBlack.svg';
import { ReactComponent as StarCheck } from './StarCheck.svg';
import { ReactComponent as StarEmpty } from './StarEmpty.svg';
import { ReactComponent as StarHalf } from './StarHalf.svg';
import { ReactComponent as StarHalfAlt } from './StarHalfAlt.svg';
import { ReactComponent as StarSmall } from './StarSmall.svg';
import { ReactComponent as Steam } from './Steam.svg';
import { ReactComponent as Stopwatch } from './Stopwatch.svg';
import { ReactComponent as Table } from './Table.svg';
import { ReactComponent as Trophy } from './Trophy.svg';
import { ReactComponent as User } from './User.svg';
import { ReactComponent as UserCheck } from './UserCheck.svg';
import { ReactComponent as UserMinus } from './UserMinus.svg';
import { ReactComponent as UserPlus } from './UserPlus.svg';
import { ReactComponent as WarningCircle } from './WarningCircle.svg';
import { ReactComponent as WarningTriangle } from './WarningTriangle.svg';
import { ReactComponent as XMark } from './XMark.svg';

const icons = {
  AnglesDown,
  AnglesUp,
  Badge,
  BirthdayCake,
  Bolt,
  Bookmark,
  Calendar,
  CalendarCheck,
  CaretLeft,
  CaretRight,
  Checklist,
  ChevronDown,
  ChevronUp,
  CircleInfo,
  CirclePlus,
  Clock,
  ClockEmpty,
  Coin,
  CoinStack,
  Crown,
  Discord,
  Donation,
  DoorOpen,
  EllipsisVertical,
  ExternalLink,
  Finish,
  Gamepad,
  Gauge,
  Grid,
  Hashtag,
  Heart,
  History,
  Home,
  Hornet,
  HourglassHalf,
  Link,
  IDCard,
  Medal,
  Patreon,
  Percent,
  Puzzle,
  Refresh,
  QuestionCircle,
  Search,
  Spin,
  SquareCheck,
  SquareMinus,
  SquarePlus,
  SquareX,
  StarBlack,
  StarCheck,
  StarEmpty,
  StarHalf,
  StarHalfAlt,
  StarSmall,
  Steam,
  Stopwatch,
  Table,
  Trophy,
  User,
  UserCheck,
  UserMinus,
  UserPlus,
  WarningCircle,
  WarningTriangle,
  XMark,
};

export type IconType = keyof typeof icons;

export default icons;
